module.exports = __webpack_public_path__ + "img/ISO20000-en.52d4d0b8.png";